import { render, staticRenderFns } from "./ActionWidget.vue?vue&type=template&id=b4add9ce&"
import script from "./ActionWidget.vue?vue&type=script&lang=js&"
export * from "./ActionWidget.vue?vue&type=script&lang=js&"
import style0 from "./ActionWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports